var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartPreCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7104 10.8418H19.8472C19.9638 10.8419 20.0622 10.9221 20.0894 11.0312L20.0972 11.0801L20.5952 21.7852C20.6018 21.9276 20.4879 22.0469 20.3452 22.0469H17.7104C17.5724 22.0469 17.4604 21.9349 17.4604 21.7969V11.0918C17.4604 10.9537 17.5724 10.8418 17.7104 10.8418Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3457 10.8418H2.20898C2.09234 10.8419 1.99398 10.9221 1.9668 11.0312L1.95898 11.0801L1.46094 21.7852C1.45431 21.9276 1.5683 22.0469 1.71094 22.0469H4.3457C4.48377 22.0469 4.5957 21.9349 4.5957 21.7969V11.0918C4.5957 10.9537 4.48377 10.8418 4.3457 10.8418Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36484 11.125H8.82067C9.37296 11.125 9.82067 11.5727 9.82067 12.125V17.5891C9.82067 18.1414 9.37296 18.5891 8.82067 18.5891H4.255",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6943 11.125H13.2423C12.69 11.125 12.2423 11.5727 12.2423 12.125V17.5891C12.2423 18.1414 12.69 18.5891 13.2423 18.5891H17.8041",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8043 10.6394V9.59068C14.8043 9.03442 14.5833 8.50094 14.19 8.10761C13.7967 7.71427 13.2632 7.4933 12.7069 7.4933H9.56088C9.00462 7.4933 8.47114 7.71427 8.07781 8.10761C7.68447 8.50094 7.4635 9.03442 7.4635 9.59068V10.7986M14.8043 5.39592L15.853 6.44461L17.9504 4.34724M13.2313 3.29855C13.2313 4.4569 12.2923 5.39592 11.1339 5.39592C9.97556 5.39592 9.03653 4.4569 9.03653 3.29855C9.03653 2.1402 9.97556 1.20117 11.1339 1.20117C12.2923 1.20117 13.2313 2.1402 13.2313 3.29855Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartPreCheck);
export default __webpack_public_path__ + "static/media/smart-pre-check.b9487094b617522169ba77e37c307937.svg";
export { ForwardRef as ReactComponent };